import React from "react";
import "./style.css";
import { Button } from "antd";
import { dentalIcons } from "../../../../../utils-icons/dentalIcons";

const ActionModal = ({
  title,
  description,
  icon,
  btnColor,
  onClick,
  btnText,
}) => {
  return (
    <div className="d_modal_container">
      <div className="d_modal_body">
        <div className="d_modal_icon">
          <img src={icon} alt="icon" />
        </div>
        <div className="d_modal_info">
          <p>{title}</p>
          <span>{description}</span>
        </div>
      </div>
      <div className="d_modal_actions">
        <div
          className="d_modal_Action"
          style={{ background: btnColor }}
          onClick={onClick}
        >
          {btnText}
        </div>
      </div>
    </div>
  );
};

export default ActionModal;
